Vue.component("presenter", {
    props: ["config"],
    template: `
        <div class="presenter">
            

            <video id="idle" :src="videoDirectory + config.idleMovie.src" autoplay playsinline muted loop></video>



            <li class="hotspot linkhotspot"  @click="play" :style="{left: config.hotspotX + 'px', top: config.hotspotY + 'px'}" :class="{'hotspot--flipped': config.flipped}">
                <div class="hotspot__title_wrapper" >
                    <h2 v-html="config.hotspotTitle"></h2>
                    <div class="hotspot-button" style="animation-name: loopPulse; animation-iteration-count: infinite; animation-duration: 15s; animation-delay: 1.5s;">
                    </div>
                </div>
            </li>

            <video id="main" :src="videoDirectory + config.mainMovie.src" style="display:none;" playsinline></video>


           <!--  <li class="hotspot skip" @click="skip">
                <i>×</i>
            </li> -->


        </div>
    `,
    data () {
        return {
            isPlaying: false,
            videoDirectory: config.BACKGROUND_VIDEO_DIRECTORY || ''

        }
    },

    mounted () {

        this.videos = {
            idle: this.$el.querySelector("#idle"),
            main: this.$el.querySelector("#main")
        }

        this.videos.main.volume = 0.5;

        this.events = {

            "play": ()=> { 
                this.isPlaying = true;
                this.videos.idle.style.display = "none";
                this.videos.main.style.display = "block";
                this.$el.querySelector(".hotspot").style.opacity = 0;

            },
            "ended": ()=> {
                this.isPlaying = false;
                this.videos.idle.style.display = "block";
                this.videos.main.style.display = "none";
                this.$el.querySelector(".hotspot").style.opacity = 1;

                app.radio.$emit("hotspot-animation-cycle-enable");
                app.radio.$emit("chevron-ended");
             },

             "loadedmetadata": () => {
                 console.log("loadedmetadata", this.videos.idle.videoWidth)
                 this.$el.style.width = this.videos.idle.videoWidth + "px";
                 this.$el.style.height = this.videos.idle.videoHeight + "px";
             }
        };

        this.videos.idle.addEventListener("loadedmetadata", this.events.loadedmetadata)
        this.videos.main.addEventListener("play", this.events.play)
        this.videos.main.addEventListener("ended", this.events.ended)
    },

    destroy () {
        this.videos.idle.removeEventListener("loadedmetadata", this.events.loadedmetadata)
        this.videos.main.removeEventListener("play", this.events.play)
        this.videos.main.removeEventListener("ended", this.events.ended)
        this.videos.forEach(v => v.pause())
    },
    methods: {
        play () {
            if(!this.isPlaying) {
                this.videos.main.play();

                app.radio.$emit("hotspot-animation-cycle-disable");
                app.radio.$emit("chevron-playing");
            }
        },
        skip () {
            this.videos.main.pause();
            this.isPlaying = false;
            this.videos.idle.style.display = "block";
            this.videos.main.style.display = "none";
            this.$el.querySelector(".hotspot").style.opacity = 1;

            app.radio.$emit("hotspot-animation-cycle-enable");
            app.radio.$emit("chevron-ended");
        }
    }
});